var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 54,
      height: 68
    },
    viewBox: "0 0 54 68"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#989696",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M16.75 37.417h20.5M27 27.167v20.5M44.083 64.75H9.917a6.833 6.833 0 0 1-6.834-6.833V10.083A6.833 6.833 0 0 1 9.917 3.25H29c.907 0 1.776.36 2.416 1l18.499 18.5c.64.64 1 1.51 1 2.415v32.752a6.833 6.833 0 0 1-6.833 6.833"
  })));
};
export default SvgFile;